export const MEDIA_TYPE = {
  IMMAGINE: 'Immagine',
  VIDEO: 'Video',
  AUDIO: 'Audio',
};
